import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { ShareSubpanel, useSurfaceSharePanelStore } from 'pinia/surface_share_panel'
import { defineAsyncComponent, onBeforeMount } from 'vue'
import SurfaceSharePanelSubmissionRequestPanel from 'vuecomponents/SurfaceSharePanelSubmissionRequestPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceSharePanel',
  setup(__props) {

const SurfaceShareMainPanel = defineAsyncComponent(() => import('vuecomponents/SurfaceShareMainPanel.vue'))
const SurfaceSharePanelPdfExportPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSharePanelPdfExportPanel.vue'),
)
const SurfaceSharePanelSectionBreakoutPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSharePanelSectionBreakoutPanel.vue'),
)
const SurfaceSharePanelEmbedPanel = defineAsyncComponent(() => import('vuecomponents/SurfaceSharePanelEmbedPanel.vue'))
const SurfaceSharePanelLtiPanel = defineAsyncComponent(() => import('vuecomponents/SurfaceSharePanelLtiPanel.vue'))
const SurfaceShareViaAnotherAppPanel = defineAsyncComponent(
  () => import('vuecomponents/SurfaceShareViaAnotherAppPanel.vue'),
)
const SurfacePanelShareModalQrCode = defineAsyncComponent(
  () => import('vuecomponents/SurfaceSharePanelModalQrCode.vue'),
)

const surfaceSharePanelStore = useSurfaceSharePanelStore()
const { xSurfaceSharePanel, xQrModal, activePanel } = storeToRefs(surfaceSharePanelStore)

onBeforeMount(() => {
  surfaceSharePanelStore.initialize()
})

return { __sfc: true,SurfaceShareMainPanel, SurfaceSharePanelPdfExportPanel, SurfaceSharePanelSectionBreakoutPanel, SurfaceSharePanelEmbedPanel, SurfaceSharePanelLtiPanel, SurfaceShareViaAnotherAppPanel, SurfacePanelShareModalQrCode, surfaceSharePanelStore, xSurfaceSharePanel, xQrModal, activePanel, ShareSubpanel, SurfaceSharePanelSubmissionRequestPanel }
}

})